import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { confirm } = Modal;

export const showDeleteConfirm = ({ title = 'Delete', content = 'Are you sure you want to delete this item?', onOk, onCancel }) => {
  confirm({
    title,
    icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
    content,
    okText: 'Delete',
    okType: 'danger',
    okButtonProps: { danger: true },
    cancelText: 'Cancel',
    onOk,
    onCancel,
  });
};

export const showConfirm = ({ title, content, onOk, okText = 'Confirm', okType = 'primary' }) => {
  confirm({
    title,
    icon: <ExclamationCircleOutlined />,
    content,
    okText,
    okType,
    cancelText: 'Cancel',
    onOk,
  });
};
